import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackBoardTemplatesGenerated.meta';

export type TrackBoardTemplatesGeneratedParams = {
  prompt: string;
  number_of_boards: number;
};

export const useTrackBoardTemplatesGenerated = () => {
  const { track } = useAnalyticsUtilities();

  const trackBoardTemplatesGenerated = useCallback(
    (params: TrackBoardTemplatesGeneratedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackBoardTemplatesGenerated };
};
